import AuthService from '@/services/AuthService'
import OrderService from '@/services/OrderService'
import ProductService from '@/services/ProductService'
import StorageCardService from '@/services/StorageCardService'
import CustomerService from '@/services/CustomerService'
import ManufacturingCommandService from '@/services/ManufacturingCommandService'
import WorkplaceService from '@/services/WorkplaceService'
import EmployeeService from './EmployeeService'
import ConfigurationService from './ConfigurationService'

export default class UnitOfWorkService {

	// constructor() {
	// 	this._authService = new AuthService()
	// 	this._orderService = new OrderService()
	// 	this._storageCardService = new StorageCardService()
	// 	this._customerService = new CustomerService()
	// 	this._manufacturingCommandService = new ManufacturingCommandService()
	// 	this._workplaceService = new WorkplaceService()
	// }

	authService() {
		// return this._authService
		return new AuthService()
	}

	orderService() {
		// return this._orderService
		return new OrderService()
	}

	productService() {
		// return this._orderService
		return new ProductService()
	}

	storageCardService() {
		// return this._storageCardService
		return new StorageCardService()
	}

	customerService() {
		// return this._customerService
		return new CustomerService()
	}

	manufacturingCommandService() {
		// return this._manufacturingCommandService
		return new ManufacturingCommandService()
	}

	workplaceService() {
		// return this._workplaceService
		return new WorkplaceService()
	}

	employeeService() {
		// return this._workplaceService
		return new EmployeeService()
	}

	configurationService() {
		// return this._workplaceService
		return new ConfigurationService()
	}
}